//import _ from 'lodash';
import React, {PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import {gridMargin} from "./general";

export default class FMPSupplierSelect extends PureComponent {
	constructor (props) {
		super(props);
		this.state = {
			supplierId : '',
		};
	}

	render () {
		const {
			label, value, path, onChange,
			suppliers,
			error, helpText, md, contained,
		} = this.props;

		const hasError = !!error;
		const _onChange = event => {
			onChange(event.target.value, path);
		};

		const content = (
			<Grid item xs={12} md={md} style={gridMargin}>
				<FormControl fullWidth={true} error={!!error}>
					<InputLabel>{label}</InputLabel>
					<Select
						value={value}
						onChange={_onChange}
						input={<Input/>}
					>
						{suppliers.map(supplier => {
							const { supplierId, name} = supplier;
							return (
								<MenuItem key={supplierId} value={supplierId}>
									{name}
								</MenuItem>
							);
						})}
					</Select>
					{hasError && <FormHelperText>{error}</FormHelperText>}
					{(helpText && !hasError) && <FormHelperText>{helpText}</FormHelperText>}
				</FormControl>
			</Grid>
		);

		if (contained) {
			return (
				<Grid spacing={2} container>
					{content}
				</Grid>
			);
		} else {
			return content;
		}
	}
}

FMPSupplierSelect.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path : PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error: PropTypes.string,

	suppliers : PropTypes.array,
	productTypes : PropTypes.array,

	justBulk : PropTypes.bool,
	noFilter : PropTypes.bool,
	md : PropTypes.number,
	helpText : PropTypes.string,
	contained : PropTypes.bool,
};

FMPSupplierSelect.defaultProps = {
	justBulk : false,
	noFilter : false,
	md : 6,
	contained : true,
};
